/** Core dependencies */
import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  List,
  Button,
  TextareaAutosize,
  Typography,
  Box,
  ListItem,
  DialogContent,
  Dialog,
  useMediaQuery
} from "@material-ui/core";
import { Link } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { environment } from "../../../environments/environment";

/** Local dependencies & Libraries */
import Services from "../../../Services";
import { helpers } from "../../../helpers";
import Snackbar from "../../../Components/Snackbar";
import DocDownload from "../../../Components/DocDownload";
import { ListItemResult } from "../../../Imports/TableImports";

/** Third party packages */
import { checkIfTrueOrFalse, showText, showTextEmpty, ValidateDate, getQuestion, getDataSheet, ValidateTextNull } from "../../../helpers/textValidation";
import { SecondApprovalNewHireQueue, statuses, YesNo } from "../../../Components/TableComponents/constants";
import DynamicFormFields from "../../../Components/InputComponents/DynamicFormFields";
import jsPDF from "jspdf";
import { formatPhoneNumber, formatSSN } from "../../../Components/dummyConstant/DummyConstant";
import DynamicTable from "../../../Components/TableComponents/DynamicTable";
import { Form, Input, Modal, theme } from "antd";
import { PrintOutlined } from "@mui/icons-material";
import ReactToPrint from "react-to-print";
import { QuesModal } from "../../../Components/Dynamics/QuesModal";
import { ModalManager } from "@mui/material";
import DynamicInput from "../../../Components/InputComponents/DynamicInput";
import { employeeStatuses } from "../../../Imports/employeeStatuses";
import QuestionaireDataSheet from "./Questionaire&DataSheet";
import roleManager from "../../../Components/roles";
import GoBack from "../../../Components/GoBackButton/GoBack";
import { seriliazeParams } from "../../../helpers/seriliazeParams";
import { gellAllLocomotiveLocations } from "../../../Services/LocomotiveServices";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";

var moment = require("moment-timezone");

const { showSnackBar } = helpers;
const { hr, employee } = Services;
const { apiPath } = environment;

const Step1 = () => {
  let history = useHistory();

  const [applicantData, setApplicantData] = useState({});
  const [resume, setResume] = useState(null);
  const [drivingLicense, setDrivingLicense] = useState(null);
  const [questionnaire, setQuestionnaire] = useState(null);
  const [socialsecurity, setSocialsecurity] = useState(null);
  const [HearAboutTGS, setHearAboutTGS] = useState(null)
  const [HATGSFromAPI, setHATGSFromAPI] = useState(null)

  // states for Form

  const [step1, setStep1] = useState({ title: '', id: null, value: null });
  const [department, setdepartment] = useState("");
  const [supervisorList, setSupervisorList] = useState({});
  const [subDeprtmentText, setSubDeprtmentText] = useState(false);
  const [statusDateTime, setStatusDateTime] = useState({
    date: moment(new Date()).local().format("MM-DD-YYYY"),
    time: moment(new Date()).local().format("hh:mm a"),
  });

  const [formFields, setFormFields] = useState({})
  const [HATGSLoader, setHATGSLoader] = useState(false)

  // dropdowns

  const [locationDropdown, setLocationDropdown] = useState([]);
  const [paytypeDropdown, setPaytypeDropdown] = useState([]);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [SubDepartmentDropdown, setSubDepartmentDropdown] = useState([]);
  const [PositionLevel, setPositionLevel] = useState([]);
  const [OpenQuesModal, setOpenQuesModal] = useState(false)
  const [QuestionnaireData, setQuestionnaireData] = useState(null)
  const [DataSheetData, setDataSheetData] = useState(null)
  const [DataSheetDataEmergency, setDataSheetDataEmergency] = useState(null)
  const [isDataSheetModalOpen, setisDataSheetModalOpen] = useState(false)
  const [payRateModal, setPayRateModal] = useState({
    flag: false,
    type: null
  })
  const location = useLocation()
  const [holdData, setHoldData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);


  const showPayRateModal = (type) => {
    setPayRateModal({
      type: type,
      flag: true
    })
  };
  const handleOkPayRateModal = () => {
    setPayRateModal(prev => { return { ...prev, flag: false } })
    // document.getElementById("comment1").focus()
  }
  const handleCancelPayRateModal = () => {
    setPayRateModal(prev => { return { ...prev, flag: false } })
    setFormFields(prev => { return { ...prev, rate: null } })
  };

  async function onformSubmit(event) {
    event.preventDefault();

    let data = {};
    if (!step1.value) {
      data = {
        employee_id: holdData?.id,
        step: 2,
        comment: formFields?.Comment1,
      };
    } else if (step1?.value) {
      data = {
        employee_id: holdData?.id,
        Supervisor_Id: formFields?.supervisor?.id,
        location_id: formFields?.positionLocation?.id,
        step1,
        position: formFields?.positionLevel?.name,
        job_code: formFields?.jobID,
        rate: formFields?.rate,
        department: department,
        full_title: formFields?.fullTitle,
        position_level: formFields?.positionLevel?.id,
        vehicle_allowance: formFields?.vehicle_allowance.toString(),
        JobType: formFields?.jobType?.name,
        // position_category: formFields?.positionCatgory?.id,
        pay_type: formFields?.payType?.id,
        SubDepartment_Id: formFields?.subDepartment?.id,
        start_date: moment(formFields?.StartDate)?.format("YYYY-MM-DD"),
        comment: formFields?.Comment1,
        offer_letter_notes: formFields?.offer_letter_notes,
        make: formFields?.make,
        model: formFields?.model,
        vin: formFields?.vin,
        license_plate: formFields?.liscence_plate,
        year: formFields?.year,
        IT: {
          computer: formFields?.Computer?.value,
          AD: formFields?.activeDirectory?.value,
          cell_phone: formFields?.companyCellPhone?.value,
          vehicle: formFields?.companyVehicle?.value,
          fuel_card: formFields?.feulCard?.value,
          comment: formFields?.Comment2,
        },
      };
    }



    try {
      let result = step1?.value ? await hr.step1(data) : await hr.reject(data);
      if (result) {
        setTimeout(() => {
          history.push("/new-hire-queue");
        }, 1500);
        return showSnackBar("Form Successfully Submitted");
      }
    } catch (exc) {

      return showSnackBar(exc.message);
    }
  }

  useEffect(async () => {
    window.scrollTo(0, 0);

    let applicantDataHistory = location?.state;
    setHoldData(applicantDataHistory);
    setApplicantData(applicantDataHistory);

    try {
      let data = await hr.getAllApplicantsByID(applicantDataHistory);

      const {
        employee: employeeData,
        files,
        // extra: { metadata: questionnaireData },
      } = data;

      setQuestionnaireData(data?.data?.questionaire)
      setDataSheetData(data?.employee)
      setDataSheetDataEmergency(data?.emergency_contact)
      //  
      const quesData = data?.data?.questionaire?.tgsComment
      setHATGSFromAPI(quesData)

      setResume(files.filter(s => s.includes('resume'))[0]);
      setDrivingLicense(files.filter(s => s.includes('state_driver_license'))[0]);
      setQuestionnaire(files.filter(s => s.includes('Questionnaire'))[0]);
      setSocialsecurity(files.filter(s => s.includes('ssc'))[0]);
    } catch (exc) {

    }

    setStatus()
  }, [HATGSLoader]);

  async function onDepartmentChange(e, value) {

    setdepartment(value?.id);
    try {
      let data = {
        id: value?.id,
      };
      let jobSubCategory = await hr.subDepartment(data);
      if (jobSubCategory.data && jobSubCategory.data.length > 0) {
        setSubDepartmentDropdown(jobSubCategory?.data);
        setSubDeprtmentText(!subDeprtmentText);
      }
    } catch (exc) {

    }
  }

  const setStatus = async () => {

    setStatusDateTime({
      date: moment(new Date()).utc().format("MM-DD-YYYY"),
      time: moment(new Date()).utc().format("hh:mm a"),
    });
    // get job catrgories options
    try {

      let position_level = await hr.getPositionLevel();
      setPositionLevel(position_level?.data);

      let params = '?'.concat(seriliazeParams({
        locationType: 'ALL,OFF'
      }))
      let locationData = await gellAllLocomotiveLocations({ params });
      setLocationDropdown(locationData?.data);

      let payLocationData = await hr.pay_type();
      setPaytypeDropdown(payLocationData?.data);

      let departmentData = await hr.department();
      setDepartmentDropdown(departmentData?.data);

      let supervisorData = await employee.get_employee_listing();
      setSupervisorList(supervisorData?.data);
    } catch (exc) {

    }
  };


  let secondApData = {
    header: SecondApprovalNewHireQueue,
    rows: [applicantData]?.map((row) => [
      row?.id + " / " + showText(row?.firstName) + " " + showText(row?.lastName),
      ValidateDate(row?.updatedAt, "new"),
      showText(row?.city) + " , " + showTextEmpty(row?.state),
      formatPhoneNumber(row?.homePhone),
      showText(row?.email),
      // row?.ssn ? formatSSN(row?.ssn) : "N/A",
      `${showText(row?.jobId)} ${row?.jobDescription ? "/" : ""} ${showTextEmpty(row?.jobDescription)}`,
      showText(row?.JobCategory?.name),
      // showText(row?.notesForHR),
    ])
  }

  const ApplicantData = [
    {
      head: "Notes for HR",
      text: showText(applicantData?.notesForHR),
      span: false,
      visibility: true,
      showButton: false,
      // onclick:""
    },
    {
      head: "How did you hear about TGS?",
      text: showText(HATGSFromAPI),
      span: false,
      visibility: true,
      showButton: true,
      onClick: () => setIsModalOpen(true)
    },
  ];

  let HATGS = [
    {
      type: 1,
      name: "How did you hear about TGS ?",
      initial: HearAboutTGS,
      isRequired: true,
      onChange: (e) => setHearAboutTGS(e),
    },
  ];


  const resumeData = {
    docName: "Resume/Employment History",
    apiPath: apiPath,
    id: applicantData?.id,
    document: resume,
  };
  const drivingLicenseData = {
    docName: "Driver's License",
    apiPath: apiPath,
    id: applicantData?.id,
    document: drivingLicense,
  };
  const questionnaireData = {
    docName: "Questionnaire",
    apiPath: apiPath,
    id: applicantData?.id,
    document: questionnaire,
  };

  const socialsecurityData = {
    docName: "Soical Security Document",
    apiPath: apiPath,
    id: applicantData?.id,
    document: socialsecurity,
  };
  const PDFDocData = [
    { data: resumeData },
    { data: drivingLicenseData },
    // { data: questionnaireData },
    // { data: socialsecurityData },
  ];

  const handleOnChange = (value, key) => {
    setFormFields({ ...formFields, [key]: value })
    if (key === "payType") {
      if (formFields?.rate > 6000 && value?.id === 1) return showPayRateModal(value?.id)
      if (formFields?.rate > 30 && value?.id === 2) return showPayRateModal(value?.id)
    }

  }



  let statusFields = [
    { type: 3, name: "Step 1 Status", isRequired: true, keyName: 'Status', key: 'title', diffonChange2: setStep1, options: statuses },
    { type: 1, name: "Date", isDisabled: true, keyName: 'Date', initial: statusDateTime.date },
    { type: 1, name: "Time", isDisabled: true, keyName: 'Date', initial: statusDateTime.time },


  ]
  let fields = [
    { type: 3, name: "Position Level", isRequired: true, keyName: 'positionLevel', key: 'name', options: PositionLevel },
    { type: 1, name: "Full Title", isRequired: true, keyName: 'fullTitle' },
    // { type: 3, name: "Position Category", isRequired: true, keyName: 'positionCatgory', key: 'title', options: jobCategoriesOption },
    { type: 3, name: "Position Location", isRequired: true, keyName: 'positionLocation', key: 'title', options: locationDropdown },

    {
      type: 3,
      name: "Part Time / Full Time",
      keyName: 'jobType',
      key: 'name',
      options: [
        { id: 'Full Time', name: "Full Time" },
        { id: 'Part Time', name: "Part Time" }
      ],
    },

    { type: 1, name: "Job Code", isRequired: true, keyName: 'jobID' },
    { type: 3, name: "Pay Type", isRequired: true, keyName: 'payType', key: 'title', options: paytypeDropdown },

    // { type: 1, fieldType: "number", name: "Rate", isRequired: true, keyName: 'rate' },
    { type: 2, name: "Start Date", isRequired: false, keyName: 'StartDate', initial: formFields?.StartDate || new Date() },
    { type: 3, name: "Department", isRequired: true, keyName: 'department', key: 'title', options: departmentDropdown, diffonChange: onDepartmentChange },
    { type: 3, name: "Sub - Department", isRequired: true, keyName: 'subDepartment', key: 'title', subKey: subDeprtmentText, options: SubDepartmentDropdown, },
    { type: 3, name: "Supervisor", isRequired: true, keyName: 'supervisor', diffKey: "supervisor", options: supervisorList },
    { type: 1, name: "Offer Letter Notes", isRequired: false, keyName: 'offer_letter_notes', diffKey: "offer_letter_notes" },
  ]

  let ITFields = [
    { type: 3, name: "Computer", isRequired: true, keyName: 'Computer', key: 'title', options: YesNo },
    { type: 3, name: "Active Directory", isRequired: true, keyName: 'activeDirectory', key: 'title', options: YesNo },
    { type: 3, name: "Company Cell Phone", isRequired: true, keyName: 'companyCellPhone', key: 'title', options: YesNo },
    { type: 3, name: "Company Vehicle", isRequired: true, keyName: 'companyVehicle', key: 'title', options: YesNo },
    { type: 3, name: "Fuel Card", isRequired: true, keyName: 'feulCard', key: 'title', options: YesNo },

  ]

  const handleVehicleAllowance = (value) => {
    const regex = /^[\d]*\.?[\d]*$/
    if (regex.test(value))
      setFormFields(prev => ({ ...prev, vehicle_allowance: value }))
    return
    // const validate = isPattern(value)
    // if (validate)
    //  
    // setFormFields({ ...formFields, vehicle_allowance: formFields?.vehicle_allowance || '' })
  }

  const handlePayRate = (value) => {
    const regex = /^[\d]*\.?[\d]*$/
    if (regex.test(value))
      setFormFields(prev => ({ ...prev, rate: value }))

    if (value > 6000 && formFields?.payType?.id === 1) return showPayRateModal(formFields?.payType?.id)
    if (value > 30 && formFields?.payType?.id === 2) return showPayRateModal(formFields?.payType?.id)

  }

  const handleCloseQuesModal = () => {
    setOpenQuesModal(false)
  }

  const onCancelDataSheetModal = () => {
    setisDataSheetModalOpen(false)
  }

  async function onSubmitEditEmergency(event) {
    event.preventDefault()

    let data = {
      id: applicantData?.id,
      about: HearAboutTGS
    }

    try {
      setHATGSLoader(true)
      let date1 = await hr.HowDidYouHere(data);
      setHATGSLoader(false)
      setIsModalOpen(false)
    }
    catch (exc) {

    }


  }


  let QDProps = {
    handleCloseQuesModal,
    onCancelDataSheetModal,
    QuestionnaireData,
    DataSheetData,
    DataSheetDataEmergency,
    OpenQuesModal,
    setOpenQuesModal,
    isDataSheetModalOpen,
    setisDataSheetModalOpen
  }

  return (
    <PageLayout className="Liq-Container HRPortal" id="newHireQueuePage">

      <QuestionaireDataSheet {...QDProps} />
      <Modal open={payRateModal?.flag} onOk={() => { }} onCancel={() => { }} footer={false} title={false} closable={false} closeIcon={<></>} width={500}>
        <div className="payrate-modal">
          <div>Are you sure {payRateModal?.type === 1 ? "biweekly salary" : "hourly pay"} is <strong>{formFields?.rate}</strong>?</div>
          <div className="btn-container">
            <button className="btn-red" onClick={handleCancelPayRateModal}>No</button>
            <button className="btn-blue" onClick={handleOkPayRateModal}>Yes</button>
          </div>
        </div>
      </Modal>


      <Grid className="PagesFrame">
        <PageHeader />
        <Grid id="PageTitle">Applicant - 1st Approval</Grid>
        {/* Page Start */}
        <form id="applicationForm" onSubmit={onformSubmit}>
          <GoBack path={"/new-hire-queue"} />
          <Grid xs={12} className="ContentPage FormTableArea">
            <Grid xs={12} container>
              <Grid xs={12}>
                <Grid className="LiqTables" style={{ marginBottom: "30px" }}>
                  <DynamicTable tableData={secondApData} Pagination={false} />
                </Grid>

                <Grid xs={12}>
                  <List>
                    <ListItemResult data={ApplicantData} />
                    {PDFDocData?.map((docdata) => (
                      <DocDownload data={docdata.data} />
                    ))}
                  </List>
                  <Grid xs={4}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                      {roleManager("employeeLookup", "sections", "questionare") &&
                        <Button
                          className="QD-Btn-link "
                          onClick={() => setOpenQuesModal(true)}
                        >
                          Questionnaire
                        </Button>
                      }
                      <Button
                        className="QD-Btn-link "
                        onClick={() => setisDataSheetModalOpen(true)}
                      >
                        Data Sheet
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Grid>

              <Grid xs={12} md={12} lg={12}>
                <Box
                  sx={{
                    display: 'grid',
                    gap: "10px 35px",
                    gridTemplateColumns: "repeat(3, 1fr)",
                  }}
                >
                  <DynamicFormFields grid={true} fields={statusFields} />
                </Box>

                {step1?.value && (
                  <div>
                    <Box
                      sx={{
                        display: 'grid',
                        gap: "10px 35px",
                        gridTemplateColumns: "repeat(2, 1fr)",
                      }}
                    >

                      <DynamicFormFields grid={true} fields={fields} onChange={handleOnChange} />

                      <Grid xs={12} className="pl14" style={{ marginTop: '30px', marginLeft: '-12px', fontWeight: 'bold' }}>Vehicle Allowance Amount
                        <TextField
                          type='text'
                          value={formFields?.vehicle_allowance || ""}
                          style={{ background: 'white', borderRadius: '10px' }}
                          id="outlined-basic"
                          errorMessages={['This field is required', 'Vehicle Allowance Amount is not valid']}
                          onChange={(e) => handleVehicleAllowance(e.target.value)}
                          required={true}
                          variant="outlined" className="w100p"
                        />

                      </Grid>

                      {formFields?.vehicle_allowance > 0 &&
                        <>
                          <Grid xs={12} className="pl14" style={{ marginTop: '30px', marginLeft: '-12px', fontWeight: 'bold' }}>Make
                            <TextField
                              type='text'
                              value={formFields?.vehicle_allowance?.make}
                              style={{ background: 'white', borderRadius: '10px' }}
                              id="outlined-basic"
                              errorMessages={['this field is required', 'Make is not valid']}
                              onChange={(e) => setFormFields({ ...formFields, make: e.target.value })}
                              required={true}
                              variant="outlined" className="w100p"
                            />

                          </Grid>
                          <Grid xs={12} className="pl14" style={{ marginTop: '30px', marginLeft: '-12px', fontWeight: 'bold' }}>Model
                            <TextField
                              type='text'
                              value={formFields?.vehicle_allowance?.model}
                              style={{ background: 'white', borderRadius: '10px' }}
                              id="outlined-basic"
                              errorMessages={['this field is required', 'Model is not valid']}
                              onChange={(e) => setFormFields({ ...formFields, model: e.target.value })}
                              required={true}
                              variant="outlined" className="w100p"
                            />
                          </Grid>
                          <Grid xs={12} className="pl14" style={{ marginTop: '30px', marginLeft: '-12px', fontWeight: 'bold' }}>Year
                            <TextField
                              type='text'
                              value={formFields?.vehicle_allowance?.year}
                              style={{ background: 'white', borderRadius: '10px' }}
                              id="outlined-basic"
                              errorMessages={['this field is required', 'Year is not valid']}
                              onChange={(e) => setFormFields({ ...formFields, year: e.target.value })}
                              required={true}
                              variant="outlined" className="w100p"
                            />
                          </Grid>
                          <Grid xs={12} className="pl14" style={{ marginTop: '30px', marginLeft: '-12px', fontWeight: 'bold' }}>VIN
                            <TextField
                              type='text'
                              value={formFields?.vehicle_allowance?.vin}
                              style={{ background: 'white', borderRadius: '10px' }}
                              id="outlined-basic"
                              errorMessages={['this field is required', 'VIN is not valid']}
                              onChange={(e) => setFormFields({ ...formFields, vin: e.target.value })}
                              required={true}
                              variant="outlined" className="w100p"
                            />
                          </Grid>
                          <Grid xs={12} className="pl14" style={{ marginTop: '30px', marginLeft: '-12px', fontWeight: 'bold' }}>License Plate
                            <TextField
                              type='text'
                              value={formFields?.vehicle_allowance?.license_plate}
                              style={{ background: 'white', borderRadius: '10px' }}
                              id="outlined-basic"
                              errorMessages={['this field is required', 'license Plate is not valid']}
                              onChange={(e) => setFormFields({ ...formFields, liscence_plate: e.target.value })}
                              required={true}
                              variant="outlined" className="w100p"
                            />
                          </Grid>
                        </>
                      }

                      <Grid xs={12} className="pl14" style={{ marginLeft: '-9px', fontWeight: 'bold', marginTop: "33px" }}> Pay Rate
                        <TextField
                          type='text'
                          value={formFields?.rate || ""}
                          style={{ background: 'white', borderRadius: '10px' }}
                          id="outlined-basic"
                          errorMessages={['this field is required', 'Pay rate is not valid']}
                          onChange={(e) => handlePayRate(e.target.value)}
                          required={true}
                          variant="outlined" className="w100p"
                        />
                        <Typography
                          variant="h6"
                          className="MuiTypography-subtitle2 MuiTypography-colorTextSecondary"
                          component="h6"
                        >
                          *For salary employees, enter bi-weekly pay amount
                        </Typography>
                      </Grid>

                    </Box>
                  </div>
                )}

                {/* ---------- */}
                {step1?.value !== null && <Grid xs={12} container>
                  <Grid xs={12} className="mt30">
                    <Grid xs={12}>
                      <Grid xs={12} className="mbold">
                        Other
                      </Grid>
                      <Grid xs={12} className="mt14">
                        <TextareaAutosize
                        maxLength={249}
                          required={!step1.value ? true : false}
                          id="comment1"
                          className="w100p"
                          rowsMin={6}
                          placeholder="Comment here"
                          onChange={(e) => handleOnChange(e.target.value, "Comment1")}
                        />
                      </Grid>
                      <Typography
                        variant="h6"
                        className="MuiTypography-subtitle2 MuiTypography-colorTextSecondary"
                        component="h6"
                      >
                        {step1?.value
                          ? `Please leave this field empty if you have no comments`
                          : `Please define the reason of rejection`}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>}

                {step1?.value && (
                  <div>
                    <Grid xs={12} className="mbold" style={{ fontSize: "20px", marginTop: "50px" }}>
                      IT Request
                    </Grid>
                    <Box
                      sx={{
                        display: 'grid',
                        gap: "10px 35px",
                        gridTemplateColumns: "repeat(2, 1fr)",
                      }}
                    >
                      <DynamicFormFields onChange={handleOnChange} fields={ITFields} grid={true} />
                    </Box>
                    <Grid xs={12} container>
                      <Grid xs={12} className="mt30">
                        <Grid xs={12}>
                          <Grid xs={12} className="mbold">
                            Comments to IT
                          </Grid>
                          <Grid xs={12} className="mt14">
                            <TextareaAutosize
                              id="comment2"
                              onChange={(e) => handleOnChange(e.target.value, "Comment2")}
                              className="w100p"
                              rowsMin={6}
                              placeholder="Comment here"
                            />
                          </Grid>
                          <Typography
                            variant="h6"
                            className="MuiTypography-subtitle2 MuiTypography-colorTextSecondary"
                            component="h6"
                          >
                            Please leave this field empty if you have no
                            comments
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                )}
              </Grid>


              <Grid xs={12} className="mt50">
                <Grid xs={12} md={8} lg={12} container justify="space-between">
                  <Link to="/new-hire-queue" className="LinkButtonBack">
                    Back
                  </Link>
                  <Button
                    type="submit"
                    className="LinkButton"
                  >
                    Save & Continue
                    {/* </Link> */}
                  </Button>
                </Grid>
              </Grid>
              {/* <div>
                  <Modal title="Basic Modal" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                    <p>
                      Emergency Contact
                    </p>
                    <input />
                  </Modal>
                </div> */}



            </Grid>
          </Grid>
        </form>


        <Dialog
          // fullScreen={fullScreen}
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          className="BroadcastMessageModal LiqTables"
          aria-labelledby="responsive-dialog-title"
        >
          <Button
            autoFocus
            onClick={() => setIsModalOpen(false)}
            className="ModalClose"
          ></Button>

          <form onSubmit={onSubmitEditEmergency}>
            <DialogContent>
              <DynamicInput fields={HATGS} />
              <Grid xs={12} container justifyContent="center" className="mt30">
                <Button type="submit" className="LinkButton">
                  Save
                </Button>
              </Grid>
            </DialogContent>
          </form>
        </Dialog>
        <Snackbar></Snackbar>
        {/* Page Start End */}
      </Grid >
    </PageLayout>
  );
};

export default Step1;
